/*! @azure/msal-browser v4.25.0 2025-10-09 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.25.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
